import { IS_REVIEW } from '../../../constants';

const getPathFor = (name = '/') => {
  const useQueryParams = IS_REVIEW;

  return (search = '') => {
    if (!useQueryParams) {
      return `/${name}${search}`;
    } else {
      const fixedSearch = new URLSearchParams(search);
      if (fixedSearch.has('path')) {
        fixedSearch.delete('path');
      }
      if (!name) {
        return '/index.html';
      }
      return `/index.html?path=${name}${fixedSearch.size ? `&${fixedSearch.toString()}` : ''}`;
    }
  };
};

export function isVocDomain(url = window.location.href) {
  const validDomains = [
    'voc.hotjar.com',
    'hj-engage-unmoderated-review',
    'voc.ew1-integration-1.hotjarians.net',
  ];
  return validDomains.some((domain) => url.includes(domain));
}

export const routes = {
  ROOT: {
    getPath: getPathFor(''),
    name: 'voc.lobby-app.index',
  },
  PRE_CHECK: {
    getPath: getPathFor('pre-check'),
    name: 'voc.lobby-app.pre-check',
  },
  PREVIEW: {
    getPath: getPathFor('preview'),
    name: 'voc.lobby-app.preview',
  },
  THANK_YOU: {
    getPath: getPathFor('thank-you'),
    name: 'voc.lobby-app.thank-you',
  },
  PROTOTYPE_RENDER: {
    getPath: getPathFor('prototype'),
    name: 'voc.lobby-app.prototype-render',
  },
};
